<template>
    <transition name="fade">
        <div class="container show">
            <h1>{{parcours.title}}</h1>
            <div class="list">
                <template v-for="(step, index) in parcours.plugs" :key="index">
                    <div :class="{active:step.active}">
                        <RouterLink :to="'/'+lng+'/o/'+id+'/p/'+step.id" :class="{clicked:step.completed}"><img :src="step.image_url"></RouterLink>

                        <!--<button @click="setActive(index)" v-if="!step.active" :class="{clicked:step.clicked}"><img :src="step.image_url">
                        </button>-->


                    </div>
                </template>
            </div>
            
        </div>
    </transition>
</template>
<script>
import { useLearnStore } from '@/stores/learn'

export default {
    name: "LearnParcours",
    components: {},
    data() {
        return {
            dataslearn: useLearnStore(),
            parcours: {},
            mobiledeploy: false,
            loaded: false,
            indexActive: 0,
        }
    },
    created() {


        this.$root.showNav = true;
        this.$root.showMenu = false;

        this.parcours = this.dataslearn.getParcours(this.id);



        /*if (this.dataslearn.journey.filter(x => x?.complete).length == 0 && this.id != this.dataslearn.journey[0]?.id) {
            this.$root.$router.push("/" + this.$root.language + "/learn")
        }


        if (this.lng !== 'fr' && this.lng !== 'es') {
            this.$root.$router.push("/"+this.$root.language+"/"+this.lng);
        } else {
            this.$root.language = this.lng
        }*/

        console.log("learnparcours",this.dataslearn, this.id, this.parcours)


    },
    methods: {
        setActive(index) {
            this.parcours.plugs.map(a => a.active = false);
            let step = this.parcours.plugs[index];
            //this.$root.addPageVisit(this.parcours.title_short+'_'+step.id);

            step.active = true;
            step.clicked = true;

            //this.$root.$router.push("/"+this.$root.language+"/o/"+this.id+"/p/"+step.id);

        }

        /*printCertificate: function() {
            if (this.parcours.obtain_date) {
                let firstname = encodeURIComponent(this.auth.user.infos.firstname);
                var lastname = encodeURIComponent(this.auth.user.infos.lastname);
                var d = new Date(this.parcours.obtain_date);
                var date = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
                var key = encodeURIComponent(btoa(firstname + ' ' + lastname + date));


                var society = [];
                for (var i in this.auth.user.groups) {
                    if (this.auth.user.groups[i].name != "defaut") society.push(this.auth.user.groups[i].name);
                }
                society = society.join(",");


                var url = 'https://onet-learn.korda.cloud/certificats/?firstname=' + firstname + '&lastname=' + lastname + '&date=' + date + '&id=' + this.parcours.id + '&key=' + key + '&society=' + society + '&lng=' + this.lng;

                window.open(url, "_new");
            }
        }*/
    },
    watch: {
        lng: function(newVal) {
            if (newVal !== 'fr' && newVal !== 'es') {
                this.$root.$router.push("/"+this.$root.language+"/"+newVal);
            } else {
                this.$root.language = this.lng
            }
        },
    },
    props: ['id', 'lng'],
}
</script>
<style scoped>
.container {
    padding: 1em 2em 2em 1em;
    opacity: 0;
    transition: all 350ms;
}

.container.show {
	opacity: 1;
}

.mobile .container {
    padding: 0em 1em 2em 1em;
}

h1 {
    color: var(--clr-blue);
    font-size: var(--fs-700);
    font-weight: 700;
    text-align: left;
    margin-bottom: 1em;
}

.list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 1em;
}

.list>div {
    border-radius: 1em;
    /*overflow: hidden;*/
}

.list>div.active {
    display: none;
}
/*.list>div.active {
    grid-column: 1 / 5;
    grid-row: 3 / 4;
    padding-top: 2em;
    min-height: 10em;
}*/

@media (max-width: 1050px) {
    .mobile .list {
        grid-template-columns: 1fr 1fr;
    }

    /*.mobile .list>div.active {
        padding-top: 2em;
        grid-column: 1 / 3;
        grid-row: 5 / 6;
    }*/
}

.list>div>a {
    width: 100%;
    height: 100%;
    appearance: none;
    border: none;
    border-radius: 1em;
    overflow: hidden;
    display: flex;
    color: var(--clr-white);
    font-size: var(--fs-300);
    font-weight: 700;

    background: linear-gradient(180deg, #023570 0%, #017DAC 100%);
    flex-direction: column;
    align-items: center;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.18);
    position: relative;

}

.list>div>a.clicked {
    filter: grayscale(100%);
}

.list>div>a>img {
    width: 100%;
    aspect-ratio: 16/9;
    object-fit: cover;
}

.list>div>a>p {
    padding: .5em;
    text-align: center;
    position: absolute;
    background: linear-gradient(180deg, #023570 0%, #017DAC 100%);
    display: block;
    width: 100%;
    bottom: 0;
}
</style>